import { ABOUT_QUERY } from "@/apollo/queries";
import Banner from "@/components/Banner";
import SimpleCard from "@/components/Card";
import StatsCard from "@/components/Card/StatsCard";
import SEOHead from "@/components/SEO";
import { useQuery } from "@apollo/client";
import { Box, Container, Flex, Text, Spinner } from "@chakra-ui/react";
import React from "react";
import Image from "next/image";
import { logMissingFieldErrors } from "@apollo/client/core/ObservableQuery";

const About = (props) => {
  const { loading, error, data } = useQuery(ABOUT_QUERY);

  if (loading) {
    return (
      <Spinner
        thickness="2px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="md"
      />
    );
  }

  if (error) {
    console.error(error);
    return null;
  }

  const {
    Banner: MainSec,
    Contact_Us,
    Images,
    Sections,
    SEO,
  } = data.aboutPage.data.attributes;

  return (
    <>
      <SEOHead title={SEO.pageTitle} description={SEO.pageDescription} />
      <Banner data={MainSec} style={{ align: "center" }} />
      <Box as={Container} maxW="7xl" px={{ base: 5,md: 8, xl:5}}>
        <Flex wrap={"wrap"} justify={"center"} textAlign={"center"}>
          {Sections.map((item, index) => {
            const { Title, Description, TitleIconSection, slug } = item;
            return (
              <Box
                my={slug == "company-stats" ? 0 : { base: 10, md: 14, lg: 16 }}
                w="100%"
                key={index}
              >
                <Text
                  fontSize={{ base: "2xl", md: "3xl" }}
                  m={"0 auto"}
                  mb={3}
                  fontWeight={500}
                  color={"blue.10"}
                  w={{ base: "100%", md: "90%", lg: "50%" }}
                >
                  {Title}
                </Text>
                <Text
                  fontWeight={"normal"}
                  fontSize={"lg"}
                  color={"lightBlue.10"}
                  w={{ base: "100%", md: "100%", lg: "90%" }}
                  m={"0 auto"}
                >
                  {Description}
                </Text>

                <Flex
                  mt={{ base: 8, md: 12 }}
                  w={"100%"}
                  justifyContent={"center"}
                  gap={8}
                  flexWrap={"wrap"}
                >
                  {TitleIconSection.map((ele, index) => {
                    const src = ele?.Icon?.data?.attributes;
                    return slug == "company-stats" ? (
                      <StatsCard
                        title={ele.Title}
                        stat={ele.Description}
                        icon={
                          <Image
                            className="mb-0"
                            src={
                              process.env.NEXT_PUBLIC_SERVER_URL +
                              ele.Icon.data.attributes.url
                            }
                            alt={ele.Icon.data.attributes.name}
                            height={64}
                            width={64}
                          />
                        }
                        key={index}
                      />
                    ) : (
                      <SimpleCard data={ele} showIcon={true} />
                    );
                  })}
                </Flex>
              </Box>
            );
          })}
        </Flex>
      </Box>
      <Banner data={Contact_Us} classNamechild />
    </>
  );
};

export default About;
